import React from 'react';
import backStars from "@/assets/img/icons/backStars.svg";

interface WelcomeMessageProps {
  text: string;
  className?: string;
  textClassName?: string;
  textAlign?: 'left' | 'center' | 'right' | 'justify';
  showOverlay?: boolean;
}

const WelcomeMessage: React.FC<WelcomeMessageProps> = ({ 
  text, 
  className = "",
  textClassName = "text-white/80 mb-8",
  textAlign = "left",
  showOverlay = true
}) => {
  const containerStyle = {
        backgroundImage: `url(${backStars})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }

  const getTextAlignClass = (align: string) => {
    switch (align) {
      case 'left':
        return 'text-left';
      case 'center':
        return 'text-center';
      case 'right':
        return 'text-right';
      case 'justify':
        return 'text-justify';
      default:
        return 'text-left';
    }
  };

  return (
    <div 
      className={`relative w-full ${className}`}
      style={containerStyle}
    >
    
      {showOverlay && (
        <div className="absolute inset-0 bg-black/30 rounded-lg"></div>
      )}
      
      <p className={`relative z-10 ${textClassName} ${getTextAlignClass(textAlign)}`}>
        {text}
      </p>
    </div>
  );
};

export default WelcomeMessage; 
